import {request} from '@/utils/request'
import {weChatrequest} from '@/utils/request'
import { praseStrEmpty } from "@/utils/lzCommon";
import { getRefreshToken } from "@/utils/auth";
export function login(data) {
  const formData = new FormData();
  formData.append("username", data.username);
  formData.append("password", data.password);
  formData.append("captchaKey", data.captchaKey);
  formData.append("captchaCode", data.captchaCode);
  return weChatrequest({
    url: '/api/v1/auth/login',
    method: 'post',
    data: data,
    // headers: {
    //   "Content-Type": "multipart/form-data",
    // },
  })
}
// 刷新令牌
export function refreshToken(token) {
  return weChatrequest({
    url: '/api/v1/auth/refresh',
    method: 'post',
    data:{refreshToken:token}
  })
}

export function createScreenTicket() {
  return weChatrequest({
    url: '/api/v1/auth/screen-ticket',
    method: 'post'
  })
}

export function login1(data) {
  return weChatrequest({
    url: '/api/v1/auth/login/verify',
    method: 'post',
    data: data,
  })
}

// 选租户登录
export function loginConfirm(data) {
  return weChatrequest({
    url: '/api/v1/auth/login/confirm',
    method: 'post',
    data: data,
  })
}

 /** 注销 接口*/
 export function logout() {
  return weChatrequest({
    url: `/api/v1/auth/logout`,
    method: "delete",
    headers: {
      "Refresh-Token": getRefreshToken() || "",
    },
  });
}

// 巡检系统登录
export function xjLogin() {
  return weChatrequest({
    url: `/api/v1/tl/login?code=dfasaofa`,
    method: "get",
  });
}

// 获取公钥
export function getPublicKey() {
  return weChatrequest({
    url: `/api/v1/auth/getPublicKey`,
    method: "get",
  });
}

/** 获取验证码 接口*/
export function getCaptcha() {
  return weChatrequest({
    url: `/api/v1/auth/captcha`,
    method: "get",
  });
}
// 获取用户信息
export function getInfo() {
  return weChatrequest({
    url: `/api/v1/users/me`,
    method: "get",
  });
}

// 更新用户头像
export function updateUserAvatar(formData) {
  return weChatrequest({
    url: `/api/v1/users/me/avatar`,
    method: "put",
    data: formData,
  });
}

// 获取路由数据列表
export function getMenusRoutes() {
  return weChatrequest({
    url: `/api/v1/menus/routes`,
    method: "get",
  });
}

// 查询部门下拉树结构
export function treeselect() {
    return request({
      url: '/system/dept/treeselect',
      method: 'get'
    })
  }
  // 查询用户列表
export function listUser(query) {
    return request({
      url: '/system/user/list',
      method: 'get',
      params: query
    })
  }
  // 用户状态修改
export function changeUserStatus(userId, status) {
    const data = {
      userId,
      status
    }
    return request({
      url: '/system/user/update/changeStatus',
      method: 'post',
      data: data
    })
  }
  // 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
      url: '/system/dict/data/dictType/' + dictType,
      method: 'get'
    })
  }
  // 查询用户详细
export function getUser(userId) {
    return request({
      url: '/system/user/' + praseStrEmpty(userId),
      method: 'get'
    })
  }
  // 新增用户
export function addUser(data) {
    return request({
      url: '/system/user',
      method: 'post',
      data: data
    })
  }
  
  // 修改用户
  export function updateUser(data) {
    return request({
      url: '/system/user/update',
      method: 'post',
      data: data
    })
  }
  
  // 删除用户
  export function delUser(userId) {
    return request({
      url: '/system/user/delete/' + userId,
      method: 'post'
    })
  }
  
  // 导出用户
  export function exportUser(query) {
    return request({
      url: "/system/user/export",
      method: 'get',
      params: query
    });
  }
  // RSA加密
// export function getPublicKey() {
//     return request({
//       url: '/system/user/getPublicKey',
//       method: 'get'
//     })
//   }
  //解锁
export function unlock(userName) {
    return request({
      url: '/user/unlock?username='+userName,
      method: 'get'
    })
  }
  // 用户密码重置
export function resetUserPwd(userId, password) {
    const data = {
      userId,
      password
    }
    return request({
      url: '/system/user/update/resetPwd',
      method: 'post',
      data: data
    })
  }
  // 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get'
  })
}
// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data: data
  })
}
// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile/update',
    method: 'post',
    data: data
  })
}
// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/update/updatePwd',
    method: 'post',
    params: data
  })
}
